module.exports = __webpack_public_path__ + "img/1018.55864f36.gif";